
async function checkLogin() {
    const data = await fetch('/sis/login');
    return !!data.ok;
}

export default checkLogin
